module.exports = __webpack_public_path__ + "static/media/logoblack.143120df.svg";